import {
  useOutletContext,
  NavLink,
  Outlet,
  useLocation,
} from "react-router-dom";
import "../../../styles/subscription.css";
import utility from "core/Utils";
import { PAGE_PERMISSIONS } from "core/Constants";

const { default: Header } = require("../Header");

const Subscription = () => {
  const location = useLocation();
  const { token, menuPermissions } = useOutletContext();

  const menus = utility.buildSubMenuFromLocation(location, menuPermissions);
  const { name, client_name } = token;

  const permCheck = menu => {
    let allowed = true;

    if (menu.permission === PAGE_PERMISSIONS.PERM_SUBSCRIPTION_CREATE) {
      // check for userwise subscription condition
      if (token.client_id && !token.userwise_subscription) {
        allowed = false;
      }
    }

    return allowed;
  };

  return (
    <div id="subscription" className="page">
      <Header user={name} client_name={client_name} title="Subscription">
        {menus.filter(permCheck).map(menu => (
          <NavLink
            className={({ isActive }) => (isActive ? "active" : undefined)}
            key={menu.item}
            to={utility.getLastPartOfPath(menu.pathname)}
          >
            {menu.item}
          </NavLink>
        ))}
      </Header>
      <Outlet context={token} />
    </div>
  );
};

export default Subscription;
